import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PAGE_URLS } from '@constants';
import { useMutation, useQueryClient } from 'react-query';
import { resetCache } from '@services/redis-cache';
import { useLocation } from 'react-router';

export const IdleTimeout = ({ clientViewing }) => {
    const queryClient = useQueryClient();
    const { AUTHORIZE } = PAGE_URLS;
    const { state: locationState } = useLocation();
    const mutation = useMutation(leadId => resetCache(leadId));

    queryClient.clear();

    const clientMessage = <h2>Your session has expired, please contact your financial consultant.</h2>;
    const repMessage = <h2>Session timeout. Please <Link to={AUTHORIZE}>login</Link> with Azure SSO.</h2>;

    useEffect(() => {
        if (locationState) {
            mutation.mutate(locationState.leadId);
        }
    }, []);

    return clientViewing ? clientMessage : repMessage;
};

export default IdleTimeout; 
